import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateProductSections } from "../../store/product/product.action";

const SECTION_OPTIONS = [
  { value: "flash_sale", label: "Flash Sale" },
  { value: "clearance_sale", label: "Clearance Sale" },
  { value: "deals", label: "Deals" },
  { value: "recommended", label: "Recommended" },
  { value: "best_selling", label: "Best Selling" },
];

const ProductSectionDialog = ({ open, onClose, product }) => {
  const dispatch = useDispatch();
  const [selectedSections, setSelectedSections] = useState([]);

  useEffect(() => {
    if (product?.productSections) {
      setSelectedSections(product.productSections);
    } else {
      setSelectedSections([]);
    }
  }, [product]);

  const handleCheckboxChange = (sectionValue) => {
    setSelectedSections((prev) =>
      prev.includes(sectionValue)
        ? prev.filter((s) => s !== sectionValue)
        : [...prev, sectionValue]
    );
  };

  const handleSave = () => {
    dispatch(updateProductSections(
      product._id,
      selectedSections
    ));
    onClose();
  };

  if (!open) return null;

  return (
    <div
      className="modal fade show"
      style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              Product Sections - {product?.productName}
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body">
            <p className="text-muted mb-3">
              Select which sections this product should appear in on the homepage:
            </p>
            <div className="row g-3">
              {SECTION_OPTIONS.map((section) => (
                <div key={section.value} className="col-6">
                  <div
                    className={`p-3 border rounded-3 cursor-pointer ${
                      selectedSections.includes(section.value)
                        ? "border-warning bg-light"
                        : ""
                    }`}
                    style={{ cursor: "pointer" }}
                    onClick={() => handleCheckboxChange(section.value)}
                  >
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={`section-${section.value}`}
                        checked={selectedSections.includes(section.value)}
                        onChange={() => handleCheckboxChange(section.value)}
                        style={{ cursor: "pointer" }}
                      />
                      <label
                        className="form-check-label fw-semibold"
                        htmlFor={`section-${section.value}`}
                        style={{ cursor: "pointer" }}
                      >
                        {section.label}
                      </label>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {selectedSections.length > 0 && (
              <div className="mt-3">
                <small className="text-muted">
                  Selected: {selectedSections.map(s =>
                    SECTION_OPTIONS.find(opt => opt.value === s)?.label
                  ).join(", ")}
                </small>
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn"
              style={{ backgroundColor: "#F0C420", color: "white" }}
              onClick={handleSave}
            >
              Save Changes
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductSectionDialog;
